module.exports = __webpack_public_path__ + "img/user.0826fb3d.svg";